export var COLORS = {
    PRIMARY: '#37576D',
    FILL: 'white',
    SECONDARY: '#74A4BC',
    HIGHLIGHTED: '#3C98E9',
    SELECTION: '#84c6ee',
    DISABLED: 'rgba(163,154,146,0.3)',
    WHITE: '#FFF',
    BLACK: '#000',
    TRANSPARENT: 'transparent',
    SELECTION_LABEL: '#162d3d',
    GRID: '#cbd3dc',
    SECONDARY_SHAPE_STROKE: '#162d3d',
    CLASH_FILL: '#FFE1E1',
    CLASH_BORDER: '#F66',
};
export var SEAT_CIRCLE_RADIUS = 12;
export var SEAT_CIRCLE_DIAMETER = SEAT_CIRCLE_RADIUS * 2;
export var OCCUPIED_SEAT_CIRCLE_DIAMETER = 8;
export var OCCUPIED_SEAT_FILL = 'rgba(0, 0, 0, 0.3)';
export var SEAT_SPACING = 12;
export var ROW_SPACING = 12;
export var MIN_TABLE_SIZE = SEAT_CIRCLE_DIAMETER * 4 + SEAT_SPACING * 2;
export var MIN_SHAPE_SIZE = 24;
export var MIN_LINE_LENGTH = 6;
export var MAX_DIMENSION = 1000000;
export var SHAPE_STROKE_COLOR = COLORS.PRIMARY;
export var SHAPE_FILL_COLOR = 'white';
export var STROKE_WIDTH = 1;
export var STROKE_WIDTH_SELECTED = 2;
export var DEFAULT_TEXT = 'TEXT';
export var AREA_DEFAULT_TEXT = 'General Admission';
export var TEXT_FONT_SIZE = 32;
export var LABEL_FONT_SIZE = 12;
export var LABEL_LINE_HEIGHT = 1.2;
export var LABEL_FONT = "normal ".concat(LABEL_FONT_SIZE, "px/").concat(LABEL_LINE_HEIGHT, "px sans-serif");
export var HANDLE_TOLERANCE = 3;
export var MAX_SEATS_IN_ROW = 50;
export var MAX_ROWS_IN_MULTIROW = 50;
export var MAX_AREA_CAPACITY = 50000;
export var MAX_SEAT_LABEL_NUMERIC = 999;
export var MAX_SEAT_LABEL_LENGTH = 3;
export var MAX_TEXT_LENGTH = 40;
export var MAX_TABLE_LABEL_LENGTH = 20;
export var MAX_SPACING_BETWEEN_SEATS = 60;
export var MAX_SHAPES = 1000;
export var MAX_SHAPES_PER_SECTOR = 100;
export var TOOL;
(function (TOOL) {
    TOOL["ROW"] = "row";
    TOOL["MULTI_ROW"] = "multiRow";
    TOOL["SELECT"] = "select";
    TOOL["PAN"] = "pan";
    TOOL["AREA"] = "area";
    TOOL["TEXT"] = "text";
    TOOL["LINE"] = "line";
    TOOL["RECTANGLE"] = "rectangle";
    TOOL["CIRCLE"] = "circle";
    TOOL["TABLE"] = "table";
    TOOL["ROUND_TABLE"] = "roundTable";
    TOOL["ICON"] = "icon";
})(TOOL || (TOOL = {}));
export var KEYBOARD_KEY;
(function (KEYBOARD_KEY) {
    KEYBOARD_KEY["DELETE"] = "delete";
    KEYBOARD_KEY["BACKSPACE"] = "backspace";
    KEYBOARD_KEY["SPACE"] = " ";
    KEYBOARD_KEY["ESCAPE"] = "escape";
})(KEYBOARD_KEY || (KEYBOARD_KEY = {}));
//# sourceMappingURL=constants.js.map